import {TaskDto, TaskFilterDto} from "@dain/tracker-client";
import React, {useEffect, useMemo, useState} from "react";
import {ElementDto} from "../../../../../common/apis/element/ElementDto";
import {DEFAULT_ARCHIREPO_EXTERNAL_IDENT, TrackerConfigDto} from "../../../../../configuration/TrackerConfigDto";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import Snackbar from "../../snackbar/Snackbar";
import TrackerService from "./TrackerService";
import TrackerTasksGrid from "./TrackerTasksGrid";

interface TrackerTasksPanelProps {
    element: ElementDto,
    trackerConfig: TrackerConfigDto,
}

export default function TrackerTasksPanel({element, trackerConfig}: TrackerTasksPanelProps) {

    const trackerService = useMemo(() => new TrackerService(trackerConfig), [trackerConfig]);
    const archirepoExternalIdent = useMemo(() => trackerConfig.archirepoExternalIdent ?? DEFAULT_ARCHIREPO_EXTERNAL_IDENT, [trackerConfig]);

    const [tasks, setTasks] = useState<TaskDto[]>([]);
    const [reload, setReload] = useState<number>(0);

    useEffect(() => {
        const filter: TaskFilterDto = {
            extIdent: element.identifier,
            extSystemIdents: [archirepoExternalIdent],
        };

        trackerService.api.taskFindByFilterUsingPOST({taskFilterDto: filter})
                .then((response => {
                    setTasks(response.resultList as TaskDto[]);
                }))
                .catch(error => {
                    setTasks([]);
                    Snackbar.error(_transl(ErrorTranslationKey.FAILED_TO_LOAD_DATA), error);
                });
    }, [element, reload, archirepoExternalIdent, trackerService]);


    function reloadTasks() {
        setReload(reload + 1);
    }


    function handleOnTaskAssigned(task: TaskDto) {
        const assignElementToTaskRequest = {
            entityIdents: [element.identifier],
            extSystemCode: archirepoExternalIdent,
            taskKey: task.key
        }

        trackerService.externalSystemsApi.attachExtEntitiesToTaskUsingPUT({request: assignElementToTaskRequest})
                .then(() => {
                    reloadTasks();
                })
                .catch(error => {
                    Snackbar.error(_transl(ErrorTranslationKey.FAILED_TO_SAVE_DATA), error);
                });
    }

    function handleOnTaskUnassigned(task: TaskDto) {
        const assignElementToTaskRequest = {
            entityIdents: [element.identifier],
            extSystemCode: archirepoExternalIdent,
            taskKey: task.key
        }

        trackerService.externalSystemsApi.detachExtEntitiesFromTaskUsingPUT({request: assignElementToTaskRequest})
                .then(() => {
                    reloadTasks();
                })
                .catch(error => {
                    Snackbar.error(_transl(ErrorTranslationKey.FAILED_TO_REMOVE_DATA), error);
                });
    }

    return (
            <>
                <TrackerTasksGrid
                        trackerService={trackerService}
                        tasks={tasks}
                        onTaskAssigned={handleOnTaskAssigned}
                        onTaskUnassigned={handleOnTaskUnassigned}
                        onRefresh={reloadTasks}
                />
            </>
    );
}
